import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "my-application"
  }, [_vm._m(0), _c('a-card', [_c('div', {
    staticClass: "search-form"
  }, [_c('a-form', {
    attrs: {
      "layout": "inline",
      "form": _vm.searchForm
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "流水号"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "请输入流水号"
    },
    model: {
      value: _vm.searchForm.id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "id", $$v);
      },
      expression: "searchForm.id"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "会议标题"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入会议标题"
    },
    model: {
      value: _vm.searchForm.meetingName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "meetingName", $$v);
      },
      expression: "searchForm.meetingName"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "会议室"
    }
  }, [_c('a-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "请选择会议室"
    },
    model: {
      value: _vm.searchForm.roomId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "roomId", $$v);
      },
      expression: "searchForm.roomId"
    }
  }, _vm._l(_vm.roomList, function (room) {
    return _c('a-select-option', {
      key: room.id,
      attrs: {
        "value": room.id
      }
    }, [_vm._v(" " + _vm._s(room.name) + " ")]);
  }), 1)], 1), _c('a-form-item', [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _c('a-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "dataSource": _vm.reservationList,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "row-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(text) {
        return [_c('a-tag', {
          attrs: {
            "color": _vm.getStatusColor(text)
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(text)))])];
      }
    }, {
      key: "action",
      fn: function fn(record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewDetail(record);
            }
          }
        }, [_vm._v("查看")])], 1), record.status === 'DRAFT' ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.editRecord(record);
            }
          }
        }, [_vm._v("编辑")])], 1) : _vm._e(), record.status === 'DRAFT' ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link",
            "danger": ""
          },
          on: {
            "click": function click($event) {
              return _vm.cancelRecord(record);
            }
          }
        }, [_vm._v("撤销")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1), _c('a-modal', {
    attrs: {
      "title": "预约详情",
      "visible": _vm.detailVisible,
      "width": 1200,
      "footer": ""
    },
    on: {
      "cancel": function cancel($event) {
        _vm.detailVisible = false;
      }
    }
  }, [_c('MeetingDetail', {
    ref: "meetingDetail",
    attrs: {
      "id": _vm.selectedId
    }
  })], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("我的申请")]), _c('span', {
    staticClass: "tip"
  }, [_vm._v("查询和管理我的会议室预约申请")])]);
}];
export { render, staticRenderFns };